<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public && $auth.ready()">
      <v-app id="inspire" class="app">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>

        <v-content>
          <!-- Page Header -->
          <!-- <page-header v-if="$route.meta.breadcrumb"></page-header> -->
          <v-toolbar dense flat color="primary">
            <v-toolbar-title class="white--text">{{
              showTitle
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <div id="page-wrapper" class="page-wrapper">
            <router-view :key="$route.fullPath"></router-view>
          </div>
          <!-- App Footer -->
          <v-footer
            height="auto"
            class="white pa-3 app--footer hidden-md-and-down"
            :absolute="false"
            color="grey lighten-4"
          >
            <v-spacer></v-spacer>
            <span class="caption"> &copy; {{ new Date().getFullYear() }} Ecotrace Solutions - 5.6.4</span>
          </v-footer>
        </v-content>

        <v-bottom-navigation
          class="hidden-md-and-up"
          :fixed="false"
          :app="true"
          v-if="$store.state.showBottomMenu"
          color="primary"
        >
          <v-btn
            v-if="!isHome()"
            value="voltar"
            @click="goBack"
            class="btn-voltar-app"
          >
            <span>Voltar</span>
            <v-icon color="primary">fa-angle-left</v-icon>
          </v-btn>

          <v-btn value="home" :to="{ name: 'Dashboard' }">
            <span>Home</span>
            <v-icon>fa-home</v-icon>
          </v-btn>

          <v-btn value="romaneio" :to="{ name: 'RomaneioIndex' }">
            <span>Romaneios</span>
            <v-icon>icofont-cow</v-icon>
          </v-btn>

          <v-btn value="feedback" :to="{ name: 'Feedback' }">
            <span>Feedback</span>
            <v-icon>fa-comment-alt</v-icon>
          </v-btn>

          <v-btn value="alertas" :to="{ name: 'Alerts' }">
            <span>Avisos</span>
            <v-badge
              right
              overlap
              color="red"
              class="bottom-nav-badge"
              v-if="$store.state.alerts > 0"
            >
              <span v-if="$store.state.alerts > 9" slot="default">9+</span>
              <span v-else slot="default">{{ $store.state.alerts }}</span>
              <v-icon>fa-bell</v-icon>
            </v-badge>
            <v-icon v-else>fa-bell</v-icon>
          </v-btn>
        </v-bottom-navigation>

        <!-- Go to top -->
        <v-navigation-drawer
          class="setting-drawer"
          temporary
          right
          v-model="rightDrawer"
          hide-overlay
          fixed
        >
        </v-navigation-drawer>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullPath"></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-app v-if="ecoappmessage.dialog">
      <v-dialog
        v-model="ecoappmessage.dialog"
        width="500"
      >
        <v-card>
          <v-card-title
            class="headline blue white--text"
          >
            {{ecoappmessage.title}}
          </v-card-title>

          <v-card-text class="pt-2">
            {{ecoappmessage.message}}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="ecoappmessage.dialog = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>

  </div>
</template>
<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import PageHeader from '@/components/PageHeader';
import AppEvents from './event';
import menu from '@/router/paths';
import axios from 'axios';
import Vue from 'vue';
import { setTimeout } from 'timers';

import appApi from './plugins/api';

export default {
  components: {
    AppDrawer,
    AppToolbar,
    PageHeader,
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    showBottomMenu: true,
    snackbar: {
      show: false,
      text: '',
      color: '',
    },
    pull_config: {
      pullText: 'Puxe para recarregar', // The text is displayed when you pull down
      triggerText: 'Solte para recarregar', // The text that appears when the trigger distance is pulled down
      loadingText: 'Recarregando...', // The text in the load
      doneText: 'Recarregando...', // Load the finished text
      failText: 'Opss...', // Load failed text
      loadedStayTime: 400, // Time to stay after loading ms
      stayDistance: 50, // Trigger the distance after the refresh
      triggerDistance: 70, // Pull down the trigger to trigger the distance
    },
    ecoappmessage : {
      dialog : false,
      title : '',
      message : ''
    }
  }),

  computed: {
    showTitle() {
      menu.forEach((item) => {
        if (item.name === this.$route.name) {
          this.title = item.title;
        }
      });
      return this.title;
    },
    _user() {
      return this.$auth.user() || {};
    }
  },

  created() {

    window.OneSignal.push(() => {
      window.OneSignal.getUserId((userId) => {
        appApi.postUserPushNotification({
          push_id : userId,
          device : 'web'
        });
      });
    });

    setInterval(()=> {
      try {
        let dataStorage = JSON.parse(localStorage.getItem('register_message'))
        if(!dataStorage || !dataStorage.data) {
          return;
        }
        localStorage.removeItem('register_message')
        dataStorage = dataStorage.data
        this.ecoappmessage.message = dataStorage.message
        this.ecoappmessage.title = dataStorage.title
        this.ecoappmessage.dialog = true
      } catch (error) {
        console.log(error)
      }
    }, 3000)

    if (this.$route.query.appversion) {
      localStorage.setItem('is_mobile', 'true');
      localStorage.setItem('mobile_version', this.$route.query.appversion);
    }

    AppEvents.forEach((item) => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.verifyNewVersion();
  },
  methods: {
    isHome() {
      if (this.$route.name == 'Dashboard' || this.$route.name == 'Home') {
        return true;
      }
      return false;
    },
    openThemeSettings() {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    },
    refresh() {
      window.location.reload();
    },

    verifyNewVersion() {
      const instance = axios.create();
      instance
        .request({
          method: 'get',
          url:
            window.location.protocol +
            '//' +
            window.location.host +
            '/manifest.json?v=' +
            new Date().getTime(),
          responseType: 'json',
        })
        .then(function(response) {
          if (
            response.data &&
            localStorage.getItem('APP_VERSION', '') != response.data.version_app
          ) {
            localStorage.setItem('APP_VERSION', response.data.version_app);
            window.location =
              window.location.href.indexOf('?') === -1
                ? window.location.href + '?v=' + response.data.version_app
                : window.location.href + '&v=' + response.data.version_app;
          }
        });
      setTimeout(() => {
        this.verifyNewVersion();
      }, 180000);
    },
    goBack() {
      this.$router.go(-1);
    },
  },

  watch: {
    '_user' : function(v) {
      if(!v || !v.id) {
        return;
      }

      let device;
      try {
        let deviceStorage = JSON.parse(localStorage.getItem('register_device'))
        if(deviceStorage && deviceStorage.device && deviceStorage.device.platform) {
          device = deviceStorage.device.platform.toLowerCase()
        }
      } catch (error) {
        console.log('device', error)
      }

      try {
        let data = JSON.parse(localStorage.getItem('register_appid'))
        if(data && data.data) {
          appApi.postUserPushNotification({
            push_id : data.data.app_id,
            device : device
          });
        }
      } catch (error) {
        console.log('push_id', error)
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
>>>html
  height: 100%!important
#appRoot
  height:100%;
.setting-fab
  top:50%!important;
  right:0;
  border-radius:0
.page-wrapper
  min-height: calc( 100vh - 48px - 56px - 48px );
  padding-bottom : 40px;
  background-color: #FFFFFF;
</style>

<style lang="scss" scoped>
.bottom-nav-badge {
  span {
    position: absolute;
    display: inline-block;
    background-color: red;
    color: white;
    top: -3px;
    right: -8px;
    min-width: 20px;
    min-height: 15px;
    padding: 3px;
    border-radius: 11px;
    text-align: center;
  }
}

.v-item-group.v-bottom-navigation .v-btn {
  min-width: 64px;
}

button.btn-voltar-app.v-btn.v-btn--contained.theme--light.v-size--default {
  min-width: 44px;
}
</style>
